import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageStrideLengthBackground = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 181.185,
	height: 94.885,
	viewBox: "0 0 181.185 94.885",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "Path_2152",
			x: 0,
			y: 0,
			width: 44.078,
			height: 81.095,
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 3,
					input: "SourceAlpha"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 3,
					result: "blur"
				}),
				/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
				/* @__PURE__ */ _jsx("feComposite", {
					operator: "in",
					in2: "blur"
				}),
				/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "Path_2153",
			x: 137.107,
			y: .29,
			width: 44.078,
			height: 81.095,
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 3,
					input: "SourceAlpha"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 3,
					result: "blur-2"
				}),
				/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
				/* @__PURE__ */ _jsx("feComposite", {
					operator: "in",
					in2: "blur-2"
				}),
				/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
			]
		})] }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_2654",
			"data-name": "Group 2654",
			transform: "translate(-1094.893 -972.115)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_2629",
					"data-name": "Group 2629",
					transform: "translate(1103.893 1041.21) rotate(-90)",
					children: [/* @__PURE__ */ _jsx("g", {
						transform: "matrix(0, 1, -1, 0, 69.1, -9)",
						filter: "url(#Path_2152)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_2152-2",
							"data-name": "Path 2152",
							d: "M17.2,63.035c12.461-1.459,5.654-19.186,5.654-28.4,0-5.795,3.225-9.83,3.225-17.768,0-7.578-3.5-16.317-10.662-16.836C5.519-.685,0,10.255,0,20.953,0,27.417,4.386,38.185,5.372,42.59,6.76,48.781,7.5,64.173,17.2,63.035Z",
							transform: "translate(9 6)",
							fill: "#28666c"
						})
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Group_243",
						"data-name": "Group 243",
						transform: "translate(12.861 12.468) rotate(90)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_190",
								"data-name": "Path 190",
								d: "M.248,4.84A6.072,6.072,0,0,0,2.807,2.606,12.232,12.232,0,0,0,3.949,0,4.04,4.04,0,0,0,.107,4.962.54.54,0,0,1,.248,4.84Z",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_191",
								"data-name": "Path 191",
								d: "M5.34,1.283a4.122,4.122,0,0,1-3.3,2.036A4.873,4.873,0,0,1,0,2.955a4.033,4.033,0,0,0,3.143,1.5A4.043,4.043,0,0,0,7.186.415,4.072,4.072,0,0,0,7.163,0C7.022,0,6.261.035,5.34,1.283Z",
								transform: "translate(0.899 3.625)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_192",
								"data-name": "Path 192",
								d: "M2.354,3.54C4.743,3.467,5.392,1.6,6.259.934A2.443,2.443,0,0,1,7.7.357C7.685.238,7.661.12,7.631.005A3.172,3.172,0,0,0,5.7.48a11.271,11.271,0,0,1-2.6,1.9A5.271,5.271,0,0,1,0,2.618a4.041,4.041,0,0,0,.252.493A5.053,5.053,0,0,0,2.354,3.54Z",
								transform: "translate(0.321 3.003)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_193",
								"data-name": "Path 193",
								d: "M.007,5.025c.209.417,1.65-.039,2.268-.423.876-.544,1.777-1.741,2.814-2.023a4.412,4.412,0,0,1,1.245-.154A4.043,4.043,0,0,0,2.895,0a12.6,12.6,0,0,1-.948,2.564C1.114,4.3-.1,4.808.007,5.025Z",
								transform: "translate(1.418 0.008)",
								fill: "#fff"
							})
						]
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_2630",
					"data-name": "Group 2630",
					transform: "translate(1241 1041.5) rotate(-90)",
					children: [/* @__PURE__ */ _jsx("g", {
						transform: "matrix(0, 1, -1, 0, 69.39, -146.11)",
						filter: "url(#Path_2153)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_2153-2",
							"data-name": "Path 2153",
							d: "M8.878,63.035c-12.461-1.459-5.654-19.186-5.654-28.4C3.223,28.843,0,24.808,0,16.87,0,9.292,3.5.553,10.661.034c9.9-.718,15.417,10.222,15.417,20.92,0,6.464-4.387,17.231-5.373,21.637C19.318,48.781,18.58,64.173,8.878,63.035Z",
							transform: "translate(146.11 6.29)",
							fill: "#28666c"
						})
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Group_244",
						"data-name": "Group 244",
						transform: "translate(12.861 5.627) rotate(90)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_190-2",
								"data-name": "Path 190",
								d: "M.248,4.84A6.072,6.072,0,0,0,2.807,2.606,12.232,12.232,0,0,0,3.949,0,4.04,4.04,0,0,0,.107,4.962.54.54,0,0,1,.248,4.84Z",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_191-2",
								"data-name": "Path 191",
								d: "M5.34,1.283a4.122,4.122,0,0,1-3.3,2.036A4.873,4.873,0,0,1,0,2.955a4.033,4.033,0,0,0,3.143,1.5A4.043,4.043,0,0,0,7.186.415,4.072,4.072,0,0,0,7.163,0C7.022,0,6.261.035,5.34,1.283Z",
								transform: "translate(0.899 3.625)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_192-2",
								"data-name": "Path 192",
								d: "M2.354,3.54C4.743,3.467,5.392,1.6,6.259.934A2.443,2.443,0,0,1,7.7.357C7.685.238,7.661.12,7.631.005A3.172,3.172,0,0,0,5.7.48a11.271,11.271,0,0,1-2.6,1.9A5.271,5.271,0,0,1,0,2.618a4.041,4.041,0,0,0,.252.493A5.053,5.053,0,0,0,2.354,3.54Z",
								transform: "translate(0.321 3.003)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_193-2",
								"data-name": "Path 193",
								d: "M.007,5.025c.209.417,1.65-.039,2.268-.423.876-.544,1.777-1.741,2.814-2.023a4.412,4.412,0,0,1,1.245-.154A4.043,4.043,0,0,0,2.895,0a12.6,12.6,0,0,1-.948,2.564C1.114,4.3-.1,4.808.007,5.025Z",
								transform: "translate(1.418 0.008)",
								fill: "#fff"
							})
						]
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_194",
					"data-name": "Path 194",
					d: "M.682,0,0,63.385",
					transform: "translate(1187.5 978.115)",
					fill: "none",
					stroke: "#707070",
					strokeLinecap: "round",
					strokeWidth: 1,
					strokeDasharray: "1 2"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_2653",
					"data-name": "Group 2653",
					transform: "translate(556 61)",
					children: [
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle_589",
							"data-name": "Rectangle 589",
							transform: "translate(543 991)",
							fill: "#58595b",
							stroke: "#707070",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								width: 45,
								height: 15,
								rx: 7.5,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								x: .5,
								y: .5,
								width: 44,
								height: 14,
								rx: 7,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Rectangle_590",
							"data-name": "Rectangle 590",
							transform: "translate(671 991)",
							fill: "#58595b",
							stroke: "#707070",
							strokeWidth: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								width: 45,
								height: 15,
								rx: 7.5,
								stroke: "none"
							}), /* @__PURE__ */ _jsx("rect", {
								x: .5,
								y: .5,
								width: 44,
								height: 14,
								rx: 7,
								fill: "none"
							})]
						}),
						/* @__PURE__ */ _jsx("text", {
							id: "Left",
							transform: "translate(556 1001)",
							fill: "#fff",
							fontSize: 9,
							fontFamily: "Montserrat-SemiBold, Montserrat",
							fontWeight: 600,
							children: /* @__PURE__ */ _jsx("tspan", {
								x: 0,
								y: 0,
								children: "Left"
							})
						}),
						/* @__PURE__ */ _jsx("text", {
							id: "Right",
							transform: "translate(683 1001)",
							fill: "#fff",
							fontSize: 9,
							fontFamily: "Montserrat-SemiBold, Montserrat",
							fontWeight: 600,
							children: /* @__PURE__ */ _jsx("tspan", {
								x: 0,
								y: 0,
								children: "Right"
							})
						})
					]
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgAverageStrideLengthBackground);
export { ForwardRef as ReactComponent };
